import PropTypes from 'prop-types';

export default function Header({ onClose }) {
  return (
    <div
      id='bf-chat-window-header'
      style={{ padding: '10px', borderBottom: '1px solid #ccc' }}
    >
      <div className='wrapper'>
        <div
          className='row'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className='col' style={{ flexGrow: 1 }}>
            <div id='bf-chat-window-header-title'>Shopping Assistant</div>
          </div>
          <div className='col'>
            <button
              id='bf-chat-window-header-close'
              onClick={onClose}
              aria-label='Close Chat'
            >
              X
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {
  onClose: PropTypes.func.isRequired, // Validate onClose as a function
};
